import { render } from "./NoDataTableAgGrid.vue?vue&type=template&id=7aa71b26"
import script from "./NoDataTableAgGrid.vue?vue&type=script&lang=js"
export * from "./NoDataTableAgGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__